import React from "react";
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
import { ReactSVG } from "react-svg";
import Progress from "react-svg-progress";
import I18n from "i18n-js";

import sortAscIcon from "../../assets/icons/table-sort-asc.svg";
import sortDescIcon from "../../assets/icons/table-sort-desc.svg";

const Table = ({ columns, data, initialState, loading, onRowClick }) => {

  const table = useReactTable({
    columns,
    data,
    initialState: initialState || {},
    debugTable: false,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const handleRowClick = (row) => {
    onRowClick && onRowClick(row?.original);
  }

  return (
    <div className="table-wrapper">
      <table>
        <thead>
          {table.getHeaderGroups().map(group => (
            <tr key={group.id}>
              {group.headers.map((header, index) => (
                <th key={header.id} colSpan={header.colSpan} className={index == 0 ? "metric-name" : ""}>
                  {header.isPlaceholder ? null : (
                    <div
                      className={header.column.getCanSort() ? "sorting-column" : ""}
                      title={header.column.getCanSort()
                        ? header.column.getNextSortingOrder() === "asc"
                          ? I18n.t("table.sort.asc")
                          : header.column.getNextSortingOrder() === "desc"
                            ? I18n.t("table.sort.desc")
                            : I18n.t("table.sort.clear")
                        : undefined
                      }
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      {flexRender(header.column.columnDef.header, header.getContext())}
                      {header.column.getCanSort() ? (
                        <div className="sorting">
                          <ReactSVG className={`icon-asc ${header.column.getIsSorted()}`} src={sortAscIcon} />
                          <ReactSVG className={`icon-desc ${header.column.getIsSorted()}`} src={sortDescIcon} />
                        </div>
                      ) : null}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {loading
            ? (
                <div className="progress-wrapper">
                  <Progress color="#265F78" size="30px" />
                </div>
              )
            : table.getRowModel().rows.map(row => (
              <tr
                key={row.id}
                style={{ backgroundColor: row.original?.background }}
                className={row.original.category === "metadata" ? "metadata" : ""}
                onClick={() => handleRowClick(row)}
              >
                {row.getVisibleCells().map((cell, index) => (
                  <td key={cell.id} className={index == 0 ? "metric-name" : ""}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}

export default Table;
